"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.language = exports.Locale = void 0;
const schema_1 = require("../schema");
var Locale;
(function (Locale) {
    Locale["HU"] = "hu";
    Locale["EN"] = "en";
})(Locale || (exports.Locale = Locale = {}));
exports.language = schema_1.Schema.enum([Locale.HU]);
